import React, { useState } from "react";
import SingleQuestion from "./SingleQuestion";
import { faq } from "./utils";

const Faq = () => {
  const [question, setQuestion] = useState(faq);
  return (
    <section className="faq section-wrapper">
      <div className="title-container">
        <h2 className="title">Frequesnt Asked Questions</h2>
      </div>
      {question.map((item) => {
        return <SingleQuestion key={item.id} {...item} />;
      })}
    </section>
  );
};

export default Faq;
